<template>
  <div>
    <!-- <div id="preloader"></div> -->
    <!-- Start of Header section ============================================= -->
    <k-header :isNewHeaderShow="isNewIndexShow"></k-header>
    <!-- Start of Header section ============================================= -->

    <!-- Start of breadcrumb section ============================================= -->
    <section v-if="!NewHomePage" id="breadcrumb" :style="'background-image: url(' + bannerBgURL + ');'" class="breadcrumb-section relative-position backgroud-style">
      <div class="blakish-overlay" style="opacity: 0"></div>
      <div class="container">
        <div class="page-breadcrumb-content text-center">
          <div class="page-breadcrumb-title">
            <h2 class="breadcrumb-head black bold">{{currModule.titleEN}} <span>{{currModule.titleCN}}</span></h2>
          </div>
        </div>
      </div>
    </section>
    <!-- End of breadcrumb section ============================================= -->

    <!-- Start of course section 内容============================================= -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" style="min-height:610px;"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" style="min-height:610px;"></router-view>
    <!-- End of course section ============================================= -->

    <!-- Start of footer section ============================================= -->
    <k-footer></k-footer>
    <!-- End of footer section ============================================= -->

    <!-- 浮窗 -->
    <div id="su_layer" class="su_layer">
      <div class="su_close" @click="closeSulayer">X</div>
      <div class="su_title">{{suspLayerTitle}}</div>
      <div @click="goNewDetails(suspLayerId)" :style="{ fontSize: suspLayerFontSize + 'px', marginTop: '10px', cursor: 'pointer' }" v-html="suspLayerContent"></div>
    </div>

    <!-- 强密码修改提示 -->
    <el-dialog id='zyts-dialog' title="" :visible.sync="zytsDialogVisible" width="500px" :show-close='false' :close-on-click-modal='false' :before-close="handleZytsDialogCancel">
      <div class="k-dialog">
        <div class="k-dialog-title">重要提示</div>
        <div class="k-dialog-content">
          <div>为了提升平台的安全性，平台已启用强密码登录。<span style="color:#ff6715">所有用户请通过登录框右下角的“重置密码”功能修改自己的密码为强密码。只有将自己的密码修改为了强密码才允许登录。</span>密码规则：大、小写字母 + 数字 + 特殊符号，不低于12位，且不包含诸如123、生日等易猜或与身份密切相关的字符串。</div>
        </div>
        <div class="k-dialog-fooler">
          <el-button @click="handleZytsDialogCancel">我已知晓</el-button>
          <el-button type="primary" @click="showForgetPassword">立即修改</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import './home/index'
import Cookies from 'js-cookie'
import { mapGetters, ProjectSettings } from './base/base.js';

const routers = [
  { path: '/index', titleEN: 'Welcome', titleCN: '欢迎' },
  { path: '/notice', titleEN: '', titleCN: '通知公告' },
  { path: '/courseDetails', titleEN: '', titleCN: '培训详情' },
  { path: '/courseEnrollStudent', titleEN: '', titleCN: '选择人员' },
  { path: '/courseEnrollAddStudent', titleEN: '', titleCN: '选择需要添加的学员' },
  { path: '/courseEnrollSubmit', titleEN: '', titleCN: '确认报名' },
  { path: '/courseEnrollPay', titleEN: '', titleCN: '在线支付' },
  { path: '/register', titleEN: '', titleCN: '企业注册' },
  { path: '/store', titleEN: '', titleCN: '培训报名' },
  { path: '/courseEnroll', titleEN: '', titleCN: '培训报名' },
  { path: '/xqhz', titleEN: '', titleCN: '校企合作' },
  { path: '/diploma', titleEN: '', titleCN: '证书查询' },
  { path: '/diplomainfo', titleEN: '', titleCN: '证书详情' },
  { path: '/certificate', titleEN: '', titleCN: '证书' },
  { path: '/studyrecord', titleEN: '', titleCN: '学习记录查询' },
  { path: '/studylessonlog', titleEN: '', titleCN: '课时学习记录' },

  { path: '/qygl/xxgl', titleEN: '', titleCN: '学习管理' },
  { path: '/qygl/xxgl/info', titleEN: '', titleCN: '学习详情' },
  { path: '/qygl/xxgl/mnksjl', titleEN: '', titleCN: '模拟测试记录' },
  { path: '/qygl/xxgl/bkbm', titleEN: '', titleCN: '补考报名' },
  { path: '/qygl/xygl', titleEN: '', titleCN: '学员管理' },
  { path: '/qygl/xygl/info', titleEN: '', titleCN: '学员详情' },
  { path: '/qygl/xygl/archive', titleEN: '', titleCN: '学员档案' },
  { path: '/qygl/wdbm', titleEN: '', titleCN: '我的培训报名' },
  { path: '/qygl/wdbm/info', titleEN: '', titleCN: '培训报名详情' },
  { path: '/qygl/wdbm/jfxx', titleEN: '', titleCN: '上传缴费信息' },
  { path: '/qygl/xyinfo', titleEN: '', titleCN: '学员信息' },
  { path: '/qygl/wdbkbm', titleEN: '', titleCN: '我的补考报名' },
  { path: '/qygl/wdbkbm/info', titleEN: '', titleCN: '补考报名详情' },
  { path: '/qygl/fpgl/dkplist', titleEN: '', titleCN: '监理人员申请开票' },
  { path: '/qygl/fpgl/apply', titleEN: '', titleCN: '申请开票' },
  { path: '/qygl/fpgl/info', titleEN: '', titleCN: '开票详情' },
  { path: '/qygl/fpgl/list', titleEN: '', titleCN: '监理人员发票下载' },
  { path: '/qygl/jcyfpgl/dkplist', titleEN: '', titleCN: '检测人员申请开票' },
  { path: '/qygl/jcyfpgl/apply', titleEN: '', titleCN: '检测人员申请开票' },
  { path: '/qygl/jcyfpgl/info', titleEN: '', titleCN: '检测人员开票详情' },
  { path: '/qygl/jcyfpgl/list', titleEN: '', titleCN: '检测人员发票下载' },
  { path: '/qygl/xmgl/list', titleEN: '', titleCN: '项目管理' },
  { path: '/qygl/xmgl/edit', titleEN: '', titleCN: '项目信息' },
  { path: '/qygl/zsgl/list', titleEN: '', titleCN: '证书管理' },
  { path: '/qygl/zsgl/info', titleEN: '', titleCN: '证书信息' },
  { path: '/qygl/zsgl/edit', titleEN: '', titleCN: '证书信息' },
  { path: '/qygl/rygl/list', titleEN: '', titleCN: '人员管理' },
  { path: '/qygl/rygl/edit', titleEN: '', titleCN: '人员信息' },
  { path: '/qygl/zsgl/import', titleEN: '', titleCN: '导入证书' },
  { path: '/qygl/wdzl', titleEN: '', titleCN: '我的资料' },
  { path: '/qygl/xgmm', titleEN: '', titleCN: '修改密码' },
  { path: '/qygl', titleEN: '', titleCN: '企业管理中心' },
  { path: '/qygl/bdypcgl', titleEN: '', titleCN: '十大员测试报名' },
  { path: '/qygl/bdypcglinfo', titleEN: '', titleCN: '十大员测试报名详情' },
  { path: '/qygl/bdypcgladdxy', titleEN: '', titleCN: '添加学员' },
  { path: '/qygl/xgsq/edit', titleEN: '', titleCN: '企业信息变更' },
  { path: '/qygl/xgsq/info', titleEN: '', titleCN: '企业信息变更详情' },
  { path: '/qygl/xgsq/concatedit', titleEN: '', titleCN: '联系信息变更' },

  { path: '/qygl/exampcgl', titleEN: '', titleCN: '测试报名' },
  { path: '/qygl/exampcglinfo', titleEN: '', titleCN: '测试报名详情' },
  { path: '/qygl/exampcgladdxy', titleEN: '', titleCN: '添加学员' },

  { path: '/qygl/bdykqlxbmadd', titleEN: '', titleCN: '十大员考前练习报名添加' },
  { path: '/qygl/bdykqlxbminfo', titleEN: '', titleCN: '十大员考前练习报名详情' },
  { path: '/qygl/bdykqlxbm', titleEN: '', titleCN: '十大员考前练习报名' },

  { path: '/qygl/zjypcgl', titleEN: '', titleCN: '三类特种测试报名' },
  { path: '/qygl/zjypcglinfo', titleEN: '', titleCN: '三类特种测试报名详情' },
  { path: '/qygl/zjypcgladdxy', titleEN: '', titleCN: '添加学员' },

  { path: '/qygl/hzsq', titleEN: '', titleCN: '换证申请' },
  { path: '/qygl/hzsq/apply', titleEN: '', titleCN: '申请换证' },
  { path: '/qygl/hzsq/info', titleEN: '', titleCN: '换证申请详情' },
  { path: '/qygl/hzsq/edit', titleEN: '', titleCN: '修改换证申请' },
  { path: '/qygl/hzsq/multipleenroll', titleEN: '', titleCN: '换证申请-批量激活' },
  { path: '/qygl/xybgsq/list', titleEN: '', titleCN: '学员变更申请' },
  { path: '/qygl/xybgsq/shlist', titleEN: '', titleCN: '学员变更申请审核' },

  { path: '/yygl/qyzcsh', titleEN: '', titleCN: '企业注册审核' },
  { path: '/yygl/qyzcshinfo', titleEN: '', titleCN: '企业信息' },
  { path: '/yygl/qyzcshedit', titleEN: '', titleCN: '审核' },
  { path: '/yygl/kcbmsh', titleEN: '', titleCN: '监理人员培训报名审核' },
  { path: '/yygl/kcjfsh', titleEN: '', titleCN: '监理人员培训缴费审核' },
  { path: '/yygl/cqjfth', titleEN: '', titleCN: '监理人员超期缴费退回' },
  { path: '/yygl/jcykcbmsh', titleEN: '', titleCN: '检测人员培训报名审核' },
  { path: '/yygl/jcykcjfsh', titleEN: '', titleCN: '检测人员培训缴费审核' },
  { path: '/yygl/jcycqjfth', titleEN: '', titleCN: '检测人员超期缴费退回' },
  { path: '/yygl/kpsqsh', titleEN: '', titleCN: '监理人员开票申请审核' },
  { path: '/yygl/kpsqshinfo', titleEN: '', titleCN: '监理人员开票详情' },
  { path: '/yygl/kpsqshqzkp', titleEN: '', titleCN: '监理人员批量强制开票' },
  { path: '/yygl/jcykpsqsh', titleEN: '', titleCN: '检测人员开票申请审核' },
  { path: '/yygl/jcykpsqshinfo', titleEN: '', titleCN: '检测人员开票详情' },
  { path: '/yygl/jcykpsqshqzkp', titleEN: '', titleCN: '检测人员批量强制开票' },
  { path: '/yygl/bkbmsh', titleEN: '', titleCN: '补考报名审核' },
  { path: '/yygl/bkjfsh', titleEN: '', titleCN: '补考缴费审核' },
  { path: '/yygl/bkktsh', titleEN: '', titleCN: '补考开通审核' },
  { path: '/yygl/kcbmshinfo', titleEN: '', titleCN: '培训报名审核' },
  { path: '/yygl/bkbmshinfo', titleEN: '', titleCN: '补考报名审核' },
  { path: '/yygl/kcgl', titleEN: '', titleCN: '考场管理' },
  { path: '/yygl/kcglinfo', titleEN: '', titleCN: '考场信息' },
  { path: '/yygl/sptbrz', titleEN: '', titleCN: '十大员必修同步日志' },
  { path: '/yygl/pcgl', titleEN: '', titleCN: '十大员批次管理' },
  { path: '/yygl/pcgledit', titleEN: '', titleCN: '十大员批次信息' },
  { path: '/yygl/pcglinfo', titleEN: '', titleCN: '十大员批次详情' },
  { path: '/yygl/pcgladdxy', titleEN: '', titleCN: '添加学员' },
  { path: '/yygl/pxjhgl', titleEN: '', titleCN: '十大员培训计划管理' },
  { path: '/yygl/pxjhglinfo', titleEN: '', titleCN: '十大员培训计划详情' },
  { path: '/yygl/pxjhgledit', titleEN: '', titleCN: '十大员培训计划信息' },
  { path: '/yygl/pxjhgladdxy', titleEN: '', titleCN: '添加学员' },
  { path: '/yygl/csjhgl', titleEN: '', titleCN: '十大员考试计划管理' },
  { path: '/yygl/csjhglinfo', titleEN: '', titleCN: '十大员考试计划详情' },
  { path: '/yygl/csjhgledit', titleEN: '', titleCN: '十大员考试计划信息' },
  { path: '/yygl/csjhgladdxy', titleEN: '', titleCN: '添加学员' },
  { path: '/yygl/zjypcgl/shlist', titleEN: '', titleCN: '三类特种测试报名审核' },
  { path: '/yygl/zjypcgl', titleEN: '', titleCN: '三类特种考试批次管理' },
  { path: '/yygl/zjypcgledit', titleEN: '', titleCN: '三类特种考试批次信息' },
  { path: '/yygl/zjypcglinfo', titleEN: '', titleCN: '三类特种考试批次详情' },

  { path: '/yygl/qygl', titleEN: '', titleCN: '企业管理' },
  { path: '/yygl/qygledit', titleEN: '', titleCN: '企业信息' },
  { path: '/yygl/qygl/archive', titleEN: '', titleCN: '企业档案' },
  { path: '/yygl/qygl/zjytest', titleEN: '', titleCN: '企业测试详情' },
  { path: '/yygl/qygl/bdytest', titleEN: '', titleCN: '企业测试详情' },
  { path: '/yygl/xygl/archive', titleEN: '', titleCN: '学员档案' },

  { path: '/yygl/xygl', titleEN: '', titleCN: '学员管理' },
  { path: '/yygl/xyglinfo', titleEN: '', titleCN: '学员管理信息' },
  // { path: '/yygl/zsdr', titleEN: '', titleCN: '证书导入' },
  { path: '/yygl', titleEN: '', titleCN: '运营管理中心' },
  { path: '/yygl/xxzx/info', titleEN: '', titleCN: '学习详情' },
  { path: '/yygl/xxgl/xxkcjl', titleEN: '', titleCN: '学习课程记录' },
  { path: '/yygl/xxgl', titleEN: '', titleCN: '学习管理' },
  { path: '/yygl/xxgl/xxksinfo', titleEN: '', titleCN: '学习课时详情' },
  { path: '/yygl/xxgl/mnksjl', titleEN: '', titleCN: '模拟测试记录' },
  { path: '/yygl/xxgl/xxjl', titleEN: '', titleCN: '学习记录' },
  { path: '/yygl/xymddc', titleEN: '', titleCN: '学员名单导出' },
  { path: '/yygl/jcy2026mddc', titleEN: '', titleCN: '检测员 2026 年度延期名单导出' },
  { path: '/yygl/jcy2027mddc', titleEN: '', titleCN: '检测员 2027 年度延期名单导出' },
  { path: '/yygl/zsgl', titleEN: '', titleCN: '证书管理' },
  { path: '/yygl/zsglinfo', titleEN: '', titleCN: '证书信息' },
  { path: '/yygl/jqcsjhgl', titleEN: '', titleCN: '测试安排管理' },
  { path: '/yygl/jqcsjhglinfo', titleEN: '', titleCN: '测试安排信息' },
  { path: '/yygl/xwgl', titleEN: '', titleCN: '新闻管理' },
  { path: '/yygl/xwglinfo', titleEN: '', titleCN: '新闻管理信息' },
  { path: '/yygl/jsgrpcgl', titleEN: '', titleCN: '技术工人批次管理' },
  { path: '/yygl/jsgrpcgledit', titleEN: '', titleCN: '技术工人批次信息' },
  { path: '/yygl/jsgrpcglinfo', titleEN: '', titleCN: '技术工人批次详情' },
  { path: '/yygl/jsgrpxjhgl', titleEN: '', titleCN: '技术工人培训计划管理' },
  { path: '/yygl/jsgrpxjhglinfo', titleEN: '', titleCN: '技术工人培训计划详情' },
  { path: '/yygl/jsgrpxjhgledit', titleEN: '', titleCN: '技术工人培训计划信息' },
  { path: '/yygl/jsgrpxjhgladdxy', titleEN: '', titleCN: '添加学员' },
  { path: '/yygl/jsgrcsjhgl', titleEN: '', titleCN: '技术工人考试计划管理' },
  { path: '/yygl/jsgrcsjhglinfo', titleEN: '', titleCN: '技术工人考试计划详情' },
  { path: '/yygl/jsgrcsjhgledit', titleEN: '', titleCN: '技术工人考试计划信息' },
  { path: '/yygl/jsgrcsjhgladdxy', titleEN: '', titleCN: '添加学员' },

  { path: '/yygl/csjhpcgl', titleEN: '', titleCN: '十大员考试批次管理' },
  { path: '/yygl/csjhpcgledit', titleEN: '', titleCN: '十大员考试批次信息' },
  { path: '/yygl/csjhpcglinfo', titleEN: '', titleCN: '十大员考试批次详情' },
  { path: '/yygl/csjhpcgladdcsjh', titleEN: '', titleCN: '添加学员' },

  { path: '/yygl/bdypcgl', titleEN: '', titleCN: '十大员批次管理' },
  { path: '/yygl/bdypcgledit', titleEN: '', titleCN: '十大员批次信息' },
  { path: '/yygl/bdypcglinfo', titleEN: '', titleCN: '十大员批次详情' },

  { path: '/yygl/bdycsjhgl', titleEN: '', titleCN: '十大员考试计划管理' },
  { path: '/yygl/bdycsjhglinfo', titleEN: '', titleCN: '十大员考试计划详情' },
  { path: '/yygl/bdycsjhgledit', titleEN: '', titleCN: '十大员考试计划信息' },
  { path: '/yygl/bdycsjhgladdxy', titleEN: '', titleCN: '添加学员' },

  { path: '/yygl/exampcgl', titleEN: '', titleCN: '测试批次管理' },
  { path: '/yygl/exampcgledit', titleEN: '', titleCN: '测试批次信息' },
  { path: '/yygl/exampcglinfo', titleEN: '', titleCN: '测试批次详情' },

  { path: '/yygl/examjhgl', titleEN: '', titleCN: '测试计划管理' },
  { path: '/yygl/examjhglinfo', titleEN: '', titleCN: '测试计划详情' },
  { path: '/yygl/examjhgledit', titleEN: '', titleCN: '测试计划信息' },
  { path: '/yygl/examjhgladdxy', titleEN: '', titleCN: '添加学员' },
  { path: '/yygl/examjhglapprovepaper', titleEN: '', titleCN: '测试成绩审核' },

  { path: '/yygl/qyxgsqgl', titleEN: '', titleCN: '企业信息变更审核' },
  { path: '/yygl/qyxgsqglinfo', titleEN: '', titleCN: '企业信息变更详情' },

  { path: '/yygl/bdykqlxsh', titleEN: '', titleCN: '十大员考前练习审核' },
  { path: '/yygl/bdykqlxshinfo', titleEN: '', titleCN: '十大员考前练习审核详情' },

  { path: '/yygl/sdytmgl', titleEN: '', titleCN: '题库查询' },

  { path: '/yygl/gkkpgl', titleEN: '', titleCN: '国控教育开票管理' },
  { path: '/yygl/pxkpgl', titleEN: '', titleCN: '培训学校开票管理' },

  { path: '/yygl/hzcssh', titleEN: '', titleCN: '换证初审审核' },
  { path: '/yygl/hzfssh', titleEN: '', titleCN: '换证复审审核' },
  { path: '/yygl/hzcssh/info', titleEN: '', titleCN: '换证申请详情' },
  { path: '/yygl/xybgsq/list', titleEN: '', titleCN: '学员变更申请记录' },

  { path: '/zxxxgl/wdxx', titleEN: '', titleCN: '我的学习' },
  { path: '/zxxxgl/wdzl', titleEN: '', titleCN: '我的资料' },
  { path: '/zxxxgl/xgmm', titleEN: '', titleCN: '修改密码' },
  { path: '/zxxxgl/xyinfo', titleEN: '', titleCN: '我的资料' },
  { path: '/zxxxgl/zsgl/list', titleEN: '', titleCN: '我的证书' },
  { path: '/zxxxgl/zsgl/info', titleEN: '', titleCN: '证书详情' },
  { path: '/zxxxgl/wdxxinfo', titleEN: '', titleCN: '学习详情' },
  { path: '/zxxxgl/wdxxalbum', titleEN: '', titleCN: '学习课时详情' },
  { path: '/zxxxgl/wkzs', titleEN: '', titleCN: '完课证明' },
  { path: '/zxxxgl/zkz', titleEN: '', titleCN: '准考证' }
]

let timer = null;
let xflo = 0;
let yflo = 0;
let yistop = false;
let xisleft = true;

export default {
  name: 'home',
  data() {
    return {
      isNewIndexShow: true,
      zytsDialogVisible: false,
      NewHomePage: ProjectSettings.NewHomePage,
      bannerBgURL: ProjectSettings.BannerBgURL,
      enableSuspLayer: false,
      suspLayerId: null,
      suspLayerTitle: '',
      suspLayerContent: '',
      suspLayerFontSize: 14
    }
  },
  computed: mapGetters({
    currModule: 'getModule'
  }),

  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter', to);
    next(vm => {
      let rou = _.find(routers, { path: to.path });
      if (rou) {
        vm.$store.dispatch('getModule', rou);
      } else {
        vm.$store.dispatch('getModule', { path: 'index', titleEN: 'Welcome', titleCN: '欢迎' });
      }

      if (vm.NewHomePage && (to.name === 'index' || to.name === 'xqhz' || to.name === 'cxsm')) {
        vm.isNewIndexShow = true;
      } else {
        vm.isNewIndexShow = false;
      }

      if (vm.enableSuspLayer) {
        if (rou && rou.path !== '/index') {
          clearInterval(timer);
          $('#su_layer').hide();
        } else {
          $('#su_layer').show();
          vm.autoMove();
        }
      }
    });
  },

  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate', to);
    let rou = _.find(routers, { path: to.path });

    if (rou) {
      this.$store.dispatch('getModule', rou);
    } else {
      this.$store.dispatch('getModule', { path: 'index', titleEN: 'Welcome', titleCN: '欢迎' });
    }

    if (this.NewHomePage && (to.name === 'index' || to.name === 'xqhz' || to.name === 'cxsm')) {
      this.isNewIndexShow = true;
    } else {
      this.isNewIndexShow = false;
    }

    console.log('to.path', to.path);
    console.log('rou', rou);
    if (this.enableSuspLayer) {
      if (rou && rou.path !== '/index') {
        clearInterval(timer);
        $('#su_layer').hide();
      } else {
        $('#su_layer').show();
        this.autoMove();
      }
    }

    next();
  },

  mounted: function () {
    let that = this;
    setTimeout(() => {
      // console.log('isZytsDialog', Cookies.get('isZytsDialog'))
      if (Cookies.get('isZytsDialog') === undefined) {
        that.zytsDialogVisible = true;
        Cookies.set('isZytsDialog', 'false');
      }
    }, 1000)

    // 获取浮窗数据
    that.$store.dispatch('getNewsSusplayer').then((res) => {
      if (res && res.Data) {
        that.enableSuspLayer = true;
        that.suspLayerId = res.Data.Id;
        that.suspLayerTitle = res.Data.SuspLayerTitle;
        that.suspLayerContent = res.Data.SuspLayerContent;
        that.suspLayerFontSize = res.Data.SuspLayerFontSize || 16; // 默认 16px

        if (that.$route.path === '/index') {
          $('#su_layer').show();
          that.autoMove();
        }
      }
    });

    // if (this.$route.path === '/index' && this.$route.query.toSection) {
    //   $('html,body').animate({ scrollTop: $('#' + vm.$route.query.toSection).offset().top }, 1000);
    // }

    $('li.cat-item').on('click', function () {
      $('li.cat-item').css('color', '#777');
      this.style.color = '#16cfd0';
    });

    $('#su_layer').mouseenter(() => {
      clearInterval(timer);
    })
    $('#su_layer').mouseleave(() => {
      that.autoMove();
    })
    $('.su_close').click(() => {
      clearInterval(timer);
      $('#su_layer').hide();
    });
  },
  methods: {
    autoMove() {
      timer = setInterval(() => {
        let kwidth = $(window).width();
        let kheight = $(window).height();

        let divwidth = $('#su_layer').width();
        let divheight = $('#su_layer').height();

        let hstop = $(window).scrollTop();
        let wsleft = $(window).scrollLeft();

        let offwidth = (kwidth - divwidth);
        let offheight = (kheight - divheight);

        if (!yistop) {
          yflo++;
          if (yflo >= offheight) {
            yistop = true;
          }
        } else {
          yflo--;
          if (yflo <= 0) {
            yistop = false;
          }
        }

        if (xisleft) {
          xflo++;
          if (xflo >= offwidth) {
            xisleft = false;
          }
        } else {
          xflo--;
          if (xflo <= 0) {
            xisleft = true;
          }
        }

        $('#su_layer').css({ 'top': yflo + hstop, 'left': xflo + wsleft });
      }, 25);
    },
    closeSulayer() {
      clearInterval(timer);
    },
    handleZytsDialogCancel() {
      this.zytsDialogVisible = false;
    },
    showForgetPassword() {
      this.zytsDialogVisible = false;
      $('#forgetPassword').modal('show');
    },
    goNewDetails(id) {
      let routeUrl = this.$router.resolve({
        path: 'notice',
        query: {
          Id: id
        }
      });
      window.open(routeUrl.href, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
.login-module {
  position: absolute;
  top: 112px;
  right: 15px;
  width: 400px;
  height: 300px;
  padding: 22px 32px 0 32px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 4px;
}
.login-module-title {
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
}
.login-module-content {
  height: 150px;
  padding-top: 30px;
  font-size: 20px;
  color: #fff;
}
.login-module .login-form {
  margin: 16px 0;
}
.login-btn-row {
  display: flex;
  justify-content: space-between;
}
.login-btn-qyzc {
  background: transparent;
  width: 120px;
  height: 50px;
  font-size: 16px;
  color: #16cfd0;
  border-color: #16cfd0;
}
.login-wjmm {
  color: #16cfd0;
  margin-top: 8px;
  text-align: right;
  cursor: pointer;
}
.yanzhenma {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  position: absolute;
  right: -100px;
  top: 5px;
  a {
    color: #16cfd0;
    padding: 0px;
    padding-bottom: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    &.disabled {
      color: #9fabab !important;
      cursor: not-allowed;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    span {
      width: 64px;
    }
  }
}
.su_layer {
  width: 256px;
  height: 256px;
  padding: 20px;
  left: 0;
  top: 0;
  color: #fff;
  position: absolute;
  /* background-image: url('../assets/img/zytz_bg.png'); */
  /* background: linear-gradient(to top right, #01a6fd 0%, #17d0cf 51%, #01a6fd 100%); */
  background-color: #01a6fd;
  background-image: linear-gradient(135deg, #01a6fd, #17d0cf);
  font-size: 24px;
  font-weight: bold;
  z-index: 10;
  display: none;
}
.su_layer a:hover {
  text-decoration: underline;
}
.su_layer .su_close {
  position: absolute;
  width: 44px;
  height: 44px;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: 12px;
  text-align: center;
  line-height: 44px;
}
</style>
<style scoped>
#zyts-dialog >>> .el-dialog {
  margin: 0 !important;
  width: 800px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue